module.exports = __webpack_public_path__ + "static/about2-27b94fff2fa78ceb4cadacd2431698d2.png";